var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.pageIsLoading)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x mx-3"}),_c('span',[_vm._v("Loading ... ")])]):_vm._e(),(_vm.token !== '' 
          && _vm.$router.currentRoute.name !== 'login'
          && (!_vm.smAndDown || !_vm.$store.state.toggle.drawer))?_c('navigation'):_vm._e(),_c('router-view',{class:{
      'smAndDown': _vm.smAndDown
    }}),_c('message-modal'),_c('spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }